// extracted by mini-css-extract-plugin
export var slide = "SuperTeamBlock-module--slide--3mZ9L";
export var box = "SuperTeamBlock-module--box--1bvmY";